import { Popover, requiredRule, ValidatedInput } from '@finbeat/react-toolkit';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { deleteOrderAgreementProlongation } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { Trans, useTranslation } from 'react-i18next';

const ProlongationAgreementDeletePopover = ({
    id,
    refetchQueryKey,
}: {
    id: number;
    refetchQueryKey: string[];
}) => {
    const api = useApi();
    const { t } = useTranslation();

    return (
        <Popover<{ dsc: string }>
            buttonIcon={faTrash}
            buttonLabel="BackOfficeDelete"
            canSave
            defaultValues={{ dsc: '' }}
            header={<Trans i18nKey="BackOfficeRemoveConsent" />}
            label="close"
            mutationFunction={(data) => deleteOrderAgreementProlongation(api, id, data.dsc)}
            textStyle="danger"
            refetchQueryKeys={refetchQueryKey}
        >
            <ValidatedInput
                name="dsc"
                type="textarea"
                label={t('BackOfficeComment')}
                rules={{
                    required: requiredRule,
                }}
            />
        </Popover>
    );
};

export default ProlongationAgreementDeletePopover;
